import { ERROR_HTTP_STATUS, type ErrorCode } from '@rp/contracts'

export class ApiError extends Error {
  readonly code: ErrorCode
  readonly status: number
  readonly path: string

  constructor(code: ErrorCode, message: string, options: { status?: number; path?: string; cause?: unknown } = {}) {
    super(message, options.cause === undefined ? undefined : { cause: options.cause })
    this.name = 'ApiError'
    this.code = code
    this.status = options.status ?? ERROR_HTTP_STATUS[code]
    this.path = options.path ?? ''
  }
}

export const isApiError = (value: unknown): value is ApiError => value instanceof ApiError
